import React from "react";

import { STRAP_TENSIONER_TYPE_OPTIONS } from "../../../types";
import { CURTAIN_TENSIONER_TYPE_OPTIONS } from "../../../data";
import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import {
  AccessoryNoteCard,
  AccessoryQuantityCard,
  AccessoryTypeQuantityCard,
} from "./AccessoriesCards";
import { OpenBasketCard, ToolboxCard } from "./AccessoriesStorage";
import { roofKey } from "./BoxStructureCards";

const AccessoriesTying = () => (
  <>
    <StructureSection titleKey={roofKey("SECTIONS.TYING")} plain>
      <CardRow columns={3}>
        <AccessoryTypeQuantityCard
          cardKey="sideCableTensioner"
          titleKey={roofKey("CARDS.SIDE_CABLE_TENSIONER")}
          options={CURTAIN_TENSIONER_TYPE_OPTIONS}
        />
        <AccessoryTypeQuantityCard
          cardKey="strapTensioners"
          titleKey={roofKey("CARDS.STRAP_TENSIONERS")}
          options={STRAP_TENSIONER_TYPE_OPTIONS}
        />
        <AccessoryNoteCard
          cardKey="frontCableTensioner"
          titleKey={roofKey("CARDS.FRONT_CABLE_TENSIONER")}
        />
      </CardRow>
      <CardRow columns={3}>
        <AccessoryNoteCard
          cardKey="recessedRings"
          titleKey={roofKey("CARDS.RECESSED_RINGS")}
        />
        <AccessoryNoteCard
          cardKey="apcRings"
          titleKey={roofKey("CARDS.APC_RINGS")}
        />
        <AccessoryNoteCard
          cardKey="additionalTyingHooks"
          titleKey={roofKey("CARDS.ADDITIONAL_TYING_HOOKS")}
        />
      </CardRow>
    </StructureSection>

    <StructureSection titleKey={roofKey("SECTIONS.STORAGE")}>
      <CardRow columns={2}>
        <ToolboxCard />
        <OpenBasketCard />
      </CardRow>
      <CardRow columns={4}>
        <AccessoryQuantityCard
          cardKey="polesBasket"
          titleKey={roofKey("CARDS.POLES_BASKET")}
        />
        <AccessoryNoteCard
          cardKey="palletJackMount"
          titleKey={roofKey("CARDS.PALLET_JACK_MOUNT")}
        />
        <AccessoryNoteCard
          cardKey="polesStorageMount"
          titleKey={roofKey("CARDS.POLES_STORAGE_MOUNT")}
        />
        <AccessoryNoteCard
          cardKey="jerrycanMount"
          titleKey={roofKey("CARDS.JERRYCAN_MOUNT")}
        />
      </CardRow>
    </StructureSection>
  </>
);

export default AccessoriesTying;
